const initialState = {
    passwordProtected: '',
    domainLock: false,
    countryLock: false,
    version: '',
};

export default initialState;
